import { UIEvent, useMemo } from 'react';

export type OnListEndReachedCallback = (params: {
  isLastPage: boolean;
  nextPage: number;
}) => void;

export const useOnScrolledUntilBottom = ({
  itemsLength,
  itemsPerPage,
  callback,
}: {
  itemsLength: number;
  itemsPerPage: number;
  callback: OnListEndReachedCallback;
}) =>
  useMemo(
    () => (e: UIEvent) => {
      const bottom =
        e.currentTarget.scrollHeight -
          e.currentTarget.scrollTop -
          e.currentTarget.clientHeight <
        1;

      if (bottom && callback) {
        const isLastPage = itemsLength % itemsPerPage !== 0;
        const currentPage = Math.ceil(itemsLength / itemsPerPage);
        callback({ isLastPage, nextPage: currentPage + 1 });
      }
    },
    [callback, itemsPerPage, itemsLength]
  );
